import React from 'react'
import { Box, Center, Heading } from '@chakra-ui/react'
import {
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    ViberIcon,
    ViberShareButton,
    WhatsappIcon,
    WhatsappShareButton,
} from 'react-share'
import { POST_SLUG } from '../../lib/constants'
import { ContainerXl } from '../../components/Containers/containers'
import { useTranslation } from 'react-i18next'

const Sharer = ({ post }) => {
    const { t } = useTranslation()
    const url = process.env.GATSBY_SITE_URL

    return (
        <ContainerXl pt={10} pb={14}>
            <Center m={0}>
                <Heading>{t('share-this-article')}</Heading>
            </Center>
            <Center mt={4}>
                <Box mx={2}>
                    <FacebookShareButton url={`${url}/${POST_SLUG}/${post.slug}`}>
                        <FacebookIcon size={36} round={true} />
                    </FacebookShareButton>
                </Box>
                <Box mx={2}>
                    <FacebookMessengerShareButton url={`${url}/${POST_SLUG}/${post.slug}`}>
                        <FacebookMessengerIcon size={36} round={true} />
                    </FacebookMessengerShareButton>
                </Box>
                <Box mx={2}>
                    <LinkedinShareButton url={`${url}/${POST_SLUG}/${post.slug}`}>
                        <LinkedinIcon size={36} round={true} />
                    </LinkedinShareButton>
                </Box>
                <Box mx={2}>
                    <WhatsappShareButton url={`${url}/${POST_SLUG}/${post.slug}`} title={post.title}>
                        <WhatsappIcon size={36} round={true} />
                    </WhatsappShareButton>
                </Box>
                <Box mx={2}>
                    <ViberShareButton url={`${url}/${POST_SLUG}/${post.slug}`} title={post.title}>
                        <ViberIcon size={36} round={true} />
                    </ViberShareButton>
                </Box>
            </Center>
        </ContainerXl>
    )
}

export default Sharer
